import React from 'react';
import { CardMedia, Stack, Typography } from '@mui/material';
import ApplicationSuccessUrl from 'assets/img/aplication-success.svg';
import { useTranslation } from 'react-i18next';

export default function SubscriptionConfirmEmail() {
  const { t } = useTranslation();

  return (
    <Stack
      spacing={8}
      alignItems="center"
      justifyContent="center"
      bgcolor="background.other"
      height="100%"
    >
      <CardMedia
        sx={{
          width: '25.6rem',
          height: '25.6rem',
        }}
        component="img"
        loading="lazy"
        src={ApplicationSuccessUrl}
        alt="Bank"
      />
      <Stack spacing={2} alignItems="center">
        <Typography textAlign="center" variant="h5">
          {t('subscription.almost_there')}
        </Typography>
        <Typography
          textAlign="center"
          variant="subtitle1"
          color="text.secondary"
        >
          {t('subscription.check_your_email')}
        </Typography>
      </Stack>
    </Stack>
  );
}
